module.exports = __webpack_public_path__ + "img/patent_image0.e484f9ec.png";